module.exports = __webpack_public_path__ + "static/media/Closed Captions Test_1633891200602.0f6a824a.vtt";